import { Pipe, PipeTransform } from '@angular/core';
import { TipoValorEnum, TipoValorLabels } from '../models/pagamento';

@Pipe({ name: "tipoValorDocumentoPipe" })
export class TipoValorDocumentoPipe implements PipeTransform {
  transform(tipo: TipoValorEnum): string {
    return TipoValorLabels[tipo];
  }
}
